import React from 'react';
import { HiOutlineArrowRightOnRectangle } from 'react-icons/hi2';
import UpsellFloatingCard from './UpsellFloatingCard';

// Non-dismissible paywall shown to free users on gated views. When the user
// belongs to a paid workspace, offers a one-click switch instead of forcing an
// upgrade.
const HardPaywall = ({ onUpgrade, paidWorkspaces = [], onSwitchWorkspace }) => {
  const switchBlock = paidWorkspaces.length > 0 && (
    <div className="mt-6 mx-auto max-w-md rounded-2xl border border-cyan-400/30 bg-cyan-500/[0.04] dark:bg-cyan-500/[0.06] p-4">
      <p className="text-sm font-semibold text-gray-800 dark:text-gray-100 mb-3">
        You're part of a paid workspace — switch to keep working:
      </p>
      <div className="space-y-2">
        {paidWorkspaces.map((ws) => (
          <button
            key={ws.id}
            onClick={() => onSwitchWorkspace?.(ws.id)}
            className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700/50 hover:border-cyan-400/50 hover:shadow-sm transition-all text-left group"
          >
            <div className="w-6 h-6 rounded-md bg-gradient-to-br from-blue-400/20 to-cyan-500/20 flex items-center justify-center flex-shrink-0">
              <span className="text-[10px] font-bold text-blue-500 dark:text-blue-400">
                {ws.name?.charAt(0)?.toUpperCase()}
              </span>
            </div>
            <span className="text-sm font-medium text-gray-700 dark:text-gray-200 flex-1 truncate">
              {ws.name}
            </span>
            <HiOutlineArrowRightOnRectangle className="w-4 h-4 text-gray-400 group-hover:text-cyan-500 transition-colors" />
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <UpsellFloatingCard
      dismissible={false}
      ctaLabel="Upgrade to PRO"
      onUpgrade={onUpgrade}
    >
      {switchBlock}
    </UpsellFloatingCard>
  );
};

export default HardPaywall;
